import React from 'react'
import { fetchOportunidadesGapStats, type OportunidadesGapStats } from '../services/statsService'

export function useOportunidadesGapStats() {
  const [stats, setStats] = React.useState<OportunidadesGapStats | null>(null)
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)

  const load = React.useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const s = await fetchOportunidadesGapStats()
      setStats(s)
    } catch (e: any) {
      setError(e?.message || 'Falha ao carregar oportunidades perdidas')
    } finally {
      setLoading(false)
    }
  }, [])

  React.useEffect(() => { load() }, [load])

  // Mant��m o dado razoavelmente atualizado com foco/refresh manual
  React.useEffect(() => {
    const onFocus = () => { load() }
    const onManual = () => { load() }
    try { window.addEventListener('focus', onFocus) } catch {}
    try { window.addEventListener('opportunities:refresh', onManual as any) } catch {}
    return () => {
      try { window.removeEventListener('focus', onFocus) } catch {}
      try { window.removeEventListener('opportunities:refresh', onManual as any) } catch {}
    }
  }, [load])

  return { stats, loading, error, reload: load }
}

